export const GET_IMAGE_LIST = 'editHouseInfo/GET_IMAGE_LIST';
export const UPDATE_HOUSE_BASIC_DATA = 'editHouseInfo/UPDATE_HOUSE_BASIC_DATA';
export const UPDATE_RENT_DATA = 'editHouseInfo/UPDATE_RENT_DATA';
export const UPDATE_HOUSE_HEADER_DATA = 'editHouseInfo/UPDATE_HOUSE_HEADER_DATA';
const initialState = {
  houseHeaderData: {
    reviewState: '',
    imgSrc: "//breaa-pic-offline-1255419371.picsh.myqcloud.com",
    back: false,
    time: '',
    houseStatus: '',
    sum_daily_nb_uniq_visitors: '',
    contacts: ''
  },
  houseBasicData: {
    negativeArr: [],
    nullArr: [],
    isLoad: 0,
    house_type_img: [],
    districtId: '',
    plot_id: '',
    cert_type: '',
    districtName: '',                           //行政区
    plotName: '',                               //小区名称
    certTypeName: '',                           //权属证件类型
    cert_no: '',                                 //权属证件编号
    address: '',                                 //房屋坐落
    build_area: '',                              //建筑面积
    house_orientations: '',                      //房屋朝向
    layer_from: '',                              //起始层数
    layer_to: '',                                //终止层
    building_layers_u: '',                       //楼栋地上层数
    bldroom_count: '',                           //室
    hall_count: '',                              //客厅
    toilet_count: '',                            //卫
    kitchen_count: '',                           //厨房
    dialogVisible: true,
  },
  rentData: {
    negativeArr: [],
    nullArr: [],
    decoration_level: '',                        //装修标准
    house_title: '',                              //房源标题'
    warm_type: '',//供暖方式
    equipments: '',//配套设置
    house_description: '',//房屋描述
    traffic_situation: '',//交通情况
    rental_mode: '1',//出租方式
    price_reques: '',//要求月租金
    pay_type_request_mortgage_month: '',
    pay_type_request_pay_month: '',
    bldroom_img: [],//室
    hall_img: [],//客厅
    toilet_img: [],//卫
    kitchen_img: [],//厨
    isLoad1: 0,
    isLoad2: 0,
    isLoad3: 0,
    isLoad4: 0,
    isOkTitle:true
  }
};
const houseDataReducer = (houseBasicData = 0, action)=> {
  switch (action.type) {
    case UPDATE_HOUSE_BASIC_DATA:
      return {
        ...houseBasicData,
        [action.subType]: action.data
      }
    default:
      return houseBasicData
  }
}
const rentDataReducer = (rentData = 0, action)=> {
  switch (action.type) {
    case UPDATE_RENT_DATA:
      return {
        ...rentData,
        [action.subType]: action.data
      }
    default:
      return rentData
  }
}
const houseHeaderDataReducer = (houseHeaderData = 0, action)=> {
  switch (action.type) {
    case UPDATE_HOUSE_HEADER_DATA:
      return {
        ...houseHeaderData,
        [action.subType]: action.data
      }
    default:
      return houseHeaderData
  }
}

export default (state = initialState, action) => {
  return {
    houseBasicData: houseDataReducer(state.houseBasicData, action),
    rentData: rentDataReducer(state.rentData, action),
    houseHeaderData: houseHeaderDataReducer(state.houseHeaderData, action)
  };
}
export const dispatch_func = {
  getImgList: (data) => {
    return dispatch => {
      dispatch({
        type: GET_IMAGE_LIST,
        data: data
      });
    }
  },
  update_houseData: (data, type) => {
    return dispatch => {
      dispatch({
        type: UPDATE_HOUSE_BASIC_DATA,
        data: data,
        subType: type
      });
    }
  },

  update_rentData: (data, type) => {
    return dispatch => {
      dispatch({
        type: UPDATE_RENT_DATA,
        data: data,
        subType: type
      });
    }
  },
  update_houseHeaderData: (data, type) => {
    return dispatch => {
      dispatch({
        type: UPDATE_HOUSE_HEADER_DATA,
        data: data,
        subType: type
      });
    }
  },
};


// WEBPACK FOOTER //
// ./src/modules/editHouseInfo.js